<template>
  <div>
    <div v-if="showIframe" class="ratio ratio-16x9">
      <iframe :src="iframeSrcSkippingEmbedly" />
    </div>
    <template v-else>
      <embedly-placeholder v-if="showPlaceholder" @click="revealIframe" />

      <div v-else-if="proxiedThumbnailUrl" class="d-flex align-items-center justify-content-center" @click="revealIframe">
        <img class="thumbnail" :src="proxiedThumbnailUrl" width="100%">
        <!-- eslint-disable-next-line vue/singleline-html-element-content-newline -->
        <primary-button type="button" class="load-button">
          {{ loadVideoButtonText }}
        </primary-button>
      </div>
    </template>
  </div>
</template>

<script>
import EmbedlyPlaceholder from './embedly-placeholder'
import embedlyPrivacyMixin from './embedly-privacy-mixin'
import PrimaryButton from '../components/buttons/primary-button.vue'

export default {
  components: { EmbedlyPlaceholder, PrimaryButton },

  mixins: [ embedlyPrivacyMixin],

  props: {
    bypassPlaceholder: {
      type: Boolean,
      required: true
    },
    embedlyIframeHtml: {
      type: String,
      required: true
    },
    provider: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      showIframe: !this.agraConfiguration.embedly.privacyMode,
      showPlaceholder: this.agraConfiguration.embedly.privacyMode && !this.bypassPlaceholder
    }
  },

  computed: {
    iframeSrcSkippingEmbedly() {
      // Extract the URL of the video on its original provider host
      // from the Embedly iframe code. Therefore, we avoid making a request to
      // any Embedly host for loading the video inside the iframe.
      const el = document.createElement('div')
      el.innerHTML = this.embedlyIframeHtml
      const fullUrl = el.firstChild.src
      return new URL(fullUrl).searchParams.get('src')
    },

    loadVideoButtonText() {
      return this.i18n.t('components.embedly.video.load', {provider: this.provider})
    }
  },

  methods: {
    revealIframe() {
      this.showIframe = true
    }
  }
}
</script>

<style scoped lang="scss">
  .thumbnail {
    cursor: pointer;
  }

  .load-button {
    position: absolute;
    z-index: 2;
  }
</style>
